export function LinkResolver(doc) {
    if (!doc) return null;

    if(doc.type === 'legislator_orientation'){
      return `/` + doc.uid
    }
    if (doc.type === 'content') {
        return `/Division/Research/Content/content-items/` + doc.uid
      }
    // route fallback
    return `/`;
  }
  